import React from 'react';
import { IProps } from './types';
import { Link } from 'react-router-dom';
import { RouterSettings } from 'constants/models/routerSettings';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const WinningAnnouncement: React.FC<IProps> = (props) => {
  /**
   * @description 得獎名單公告 Click 事件
  */
  const handleBtnClick = (e:React.MouseEvent<HTMLAnchorElement>, sn:any) => {
    if (sn === 0 || isNaN(sn)) {
      e.preventDefault();
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '目前尚未有得獎名單公告'
      });
    }

    storageService.setItem(storageKeys.PrizeWinnerSn, `${props.prizeWinnerSn}`);
  };

  return (
    <div className="winning-announcement">
      <div className="template-container">
        <div className="template-content">
          <div className="winning-announcement__title-section">
            <div className="winning-announcement__title">得獎公告</div>
          </div>
          <div className="winning-announcement__content">
            <p>
              本公司將於抽獎後7日內於官網（
              <a href="/promotions-inner-page-a" className="element__link">https://www.wwunion.com</a>
              ）公布得獎名單，並以E-mail通知要保人(以下稱得獎者)。<br />
              得獎者須於接獲通知之日起10日內完成領獎，逾期視同自動放棄得獎資格。
            </p>
          </div>
          <div className="winning-announcement__control">
            <Link
              to={RouterSettings.Promotions.Announcement}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e:React.MouseEvent<HTMLAnchorElement>) => handleBtnClick(e, props.prizeWinnerSn)}
              className="element__link winning-announcement__btn"
            >
              得獎名單公佈
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinningAnnouncement;
